module.exports = __webpack_public_path__ + "static/img/pic_warning.9f52a27a.png";